/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PatientResponsibleAmountViewModel {
  datasetId?: string;
  patientId?: string;
  accountNumber?: number;
  firstName?: string | null;
  lastName?: string | null;
  locationCode?: string | null;
  locationName?: string | null;
  financialClassId?: string;
  financialClassCode?: string | null;
  financialClassName?: string | null;
  delinquencyCode?: number;
  statementType?: string | null;
  statementDate?: string | null;
  statementBalance?: number;
  balanceDue?: number;
}
